import { ActionIcon, Badge, Button, Group, Modal, Paper, Tooltip, Transition } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconTrash, IconX } from "@tabler/icons-react";
import { useMemo } from "react";
import { COLORS } from "../../../../constants/colorConstants";
import useAuth from "../../../../hooks/core/useAuth";
import { canDeleteCalendar } from "../utils/permissionsUtils";
import CalendarDeletionDialog from "./CalendarDeletionDialog";

export default function BulkActionsToolbar({ selectedRecords, onClearSelection }) {
  const { staffProfile } = useAuth();
  const [opened, { open, close }] = useDisclosure(false);

  const calendarIds = selectedRecords?.map((calendar) => calendar.id) ?? [];
  const shouldMount = calendarIds.length > 0;

  const canDelete = useMemo(() => canDeleteCalendar(staffProfile), [staffProfile]);

  return (
    <>
      <Transition mounted={shouldMount} transition="slide-up" duration={400} timingFunction="ease">
        {(styles) => (
          <Paper
            style={{
              ...styles,
              position: "sticky",
              bottom: "20px",
              left: 0,
              right: 0,
              zIndex: 100,
            }}
            shadow="md"
            p="md"
            radius="md"
            withBorder
          >
            <Group position="apart">
              <Group>
                <CountBadge count={calendarIds.length} />
                <ClearButton onClearSelection={onClearSelection} />
              </Group>
              <Group>
                <DeleteButton disabled={!canDelete} onClick={open} />
              </Group>
            </Group>
          </Paper>
        )}
      </Transition>
      <Modal opened={opened} onClose={close} centered transitionProps={{ transition: "fade", duration: 200 }} size="xl">
        <CalendarDeletionDialog calendarIds={calendarIds} />
      </Modal>
    </>
  );
}

function CountBadge({ count }) {
  return (
    <Badge size="xl" c={COLORS.WHEAT} bg={COLORS.DARK_BROWN} radius="md" p="sm">
      {count} calendars selected
    </Badge>
  );
}

function ClearButton({ onClearSelection }) {
  return (
    <Tooltip label="Clear selection">
      <ActionIcon variant="light" c={COLORS.WHEAT} bg={COLORS.DARK_BROWN} onClick={onClearSelection} radius="xl">
        <IconX size={16} />
      </ActionIcon>
    </Tooltip>
  );
}

function DeleteButton({ disabled, onClick }) {
  return (
    <Button
      disabled={disabled}
      leftSection={<IconTrash size={14} />}
      color="red"
      radius="md"
      size="sm"
      onClick={onClick}
    >
      Delete
    </Button>
  );
}
